import AbstractKeys from '../all/AbstractKeys'


class ZeasnKeys extends AbstractKeys {
    constructor() {
        super();
        if(window && window.navigator.platform.includes('Android'))
        {
            this.keys = {
                UP: (typeof(KEYCODE_DPAD_UP) !== "undefined")?KEYCODE_DPAD_UP:38,
                DOWN: (typeof(KEYCODE_DPAD_DOWN) !== "undefined")?KEYCODE_DPAD_DOWN:40,
                LEFT: (typeof(KEYCODE_DPAD_LEFT) !== "undefined")?KEYCODE_DPAD_LEFT:37,
                RIGHT:(typeof(KEYCODE_DPAD_RIGHT) !== "undefined")?KEYCODE_DPAD_RIGHT:39,
                OK: (typeof(KEYCODE_ENTER) !== "undefined")?KEYCODE_ENTER:13,
                RED:(typeof(KEYCODE_PROG_RED) !== "undefined")?KEYCODE_PROG_RED:403,
                GREEN:(typeof(KEYCODE_PROG_GREEN) !== "undefined")?KEYCODE_PROG_GREEN:404,
                YELLOW:(typeof(KEYCODE_PROG_YELLOW) !== "undefined")?KEYCODE_PROG_YELLOW:405,
                BLUE:(typeof(KEYCODE_PROG_BLUE) !== "undefined")?KEYCODE_PROG_BLUE:406,
                BACK:(typeof(KEYCODE_BACK) !== "undefined")?KEYCODE_BACK:461,
                EXIT: null,

                ZERO: (typeof(KEYCODE_0) !== "undefined")?KEYCODE_0:48,
                ONE: (typeof(KEYCODE_1) !== "undefined")?KEYCODE_1:49,
                TWO: (typeof(KEYCODE_2) !== "undefined")?KEYCODE_2:50,
                THREE:(typeof(KEYCODE_3) !== "undefined")?KEYCODE_3:51,
                FOUR: (typeof(KEYCODE_4) !== "undefined")?KEYCODE_4:52,
                FIVE: (typeof(KEYCODE_5) !== "undefined")?KEYCODE_5:53,
                SIX: (typeof(KEYCODE_6) !== "undefined")?KEYCODE_6:54,
                SEVEN: (typeof(KEYCODE_7) !== "undefined")?KEYCODE_7:55,
                EIGHT: (typeof(KEYCODE_8) !== "undefined")?KEYCODE_8:56,
                NINE: (typeof(KEYCODE_9) !== "undefined")?KEYCODE_9:57,

                PLAY: (typeof(KEYCODE_MEDIA_PLAY) !== "undefined")?KEYCODE_MEDIA_PLAY:41,
                RWD: (typeof(KEYCODE_MEDIA_REWIND) !== "undefined")?KEYCODE_MEDIA_REWIND:412,
                FWD: (typeof(KEYCODE_MEDIA_FAST_FOWARD) !== "undefined")?KEYCODE_MEDIA_FAST_FOWARD:417,
                STOP: (typeof(KEYCODE_MEDIA_STOP) !== "undefined")?KEYCODE_MEDIA_STOP:413,
                PAUSE: (typeof(KEYCODE_MEDIA_PAUSE) !== "undefined")?KEYCODE_MEDIA_PAUSE:419,

                CH_UP: 427,
                CH_DOWN: 428,
            };
        } else if(window && window.navigator.platform.includes('Linux')) {
             this.keys = {
                UP: (typeof(VK_UP) !== "undefined")?VK_UP:38,
                DOWN: (typeof(VK_DOWN) !== "undefined")?VK_DOWN:40,
                LEFT: (typeof(VK_LEFT) !== "undefined")?VK_LEFT:37,
                RIGHT: (typeof(VK_RIGHT) !== "undefined")?VK_RIGHT:39,
                OK: (typeof(VK_ENTER) !== "undefined")?VK_ENTER:13,
                RED: (typeof(VK_RED) !== "undefined")?VK_RED:403,
                GREEN: (typeof(VK_GREEN) !== "undefined")?VK_GREEN:404,
                YELLOW: (typeof(VK_YELLOW) !== "undefined")?VK_YELLOW:405,
                BLUE: (typeof(VK_BLUE) !== "undefined")?VK_BLUE:406,
                BACK: (typeof(VK_BACK) !== "undefined")?VK_BACK:461,
                EXIT: null,

                ZERO: (typeof(VK_0) !== "undefined")?VK_0:48,
                ONE: (typeof(VK_1) !== "undefined")?VK_1:49,
                TWO: (typeof(VK_2) !== "undefined")?VK_2:50,
                THREE: (typeof(VK_3) !== "undefined")?VK_3:51,
                FOUR: (typeof(VK_4) !== "undefined")?VK_4:52,
                FIVE: (typeof(VK_5) !== "undefined")?VK_5:53,
                SIX: (typeof(VK_6) !== "undefined")?VK_6:54,
                SEVEN: (typeof(VK_7) !== "undefined")?VK_7:55,
                EIGHT: (typeof(VK_8) !== "undefined")?VK_8:56,
                NINE: (typeof(VK_9) !== "undefined")?VK_9:57,

                PLAY: (typeof(VK_PLAY) !== "undefined")?VK_PLAY:41,
                RWD: (typeof(VK_REWIND) !== "undefined")?VK_REWIND:412,
                FWD: (typeof(VK_FAST_FWD) !== "undefined")?VK_FAST_FWD: 417,
                STOP: (typeof(VK_STOP) !== "undefined")?VK_STOP:413,
                PAUSE: (typeof(VK_PAUSE) !== "undefined")?VK_PAUSE:19,

                CH_UP: (typeof(VK_CHANNEL_UP) !== "undefined")?VK_CHANNEL_UP:427,
                CH_DOWN: (typeof(VK_CHANNEL_DOWN) !== "undefined")?VK_CHANNEL_DOWN:428
            };
            
        } else {
            this.keys = {
                UP: 38,
                DOWN: 40,
                LEFT: 37,
                RIGHT: 39,
                OK: 13,
                RED:403,
                GREEN:404,
                YELLOW:405,
                BLUE:406,
                BACK:461,
                EXIT: null,
    
                ZERO: 48,
                ONE: 49,
                TWO: 50,
                THREE: 51,
                FOUR: 52,
                FIVE: 53,
                SIX: 54,
                SEVEN: 55,
                EIGHT: 56,
                NINE: 57,
    
                PLAY: 41,
                RWD: 412,
                FWD: 417,
                STOP: 413,
                PAUSE: 19,
    
                CH_UP: 427,
                CH_DOWN: 428,
            };
        }
    }
}

export default ZeasnKeys;



// WEBPACK FOOTER //
// ./src/devices/zeasn/Keys.js